// extracted by mini-css-extract-plugin
export default {"root":"FI02L3rUhb7HUvoIKAjR","wrap":"rJkJa3uluRH2Kp6xqzvF","heading":"USC8RNK6TPaWNTuVaFhU","icon":"TwxUT62tgP5PcuSNneYQ","description":"Oi7IoLATww4F7NxKTPJG"};